/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_action__open_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Das Panel öffnen`
};

const en_action__open_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Open the panel`
};

const es_action__open_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Abrir el panel`
};

const fr_action__open_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Ouvrir le panneau`
};

const it_action__open_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Aprire il pannello`
};

const nl_action__open_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Open het paneel`
};

const pt_action__open_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Abrir o painel`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const action__open_panel = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.action__open_panel(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("action__open_panel", locale)
	if (locale === "de") return de_action__open_panel(inputs)
	if (locale === "en") return en_action__open_panel(inputs)
	if (locale === "es") return es_action__open_panel(inputs)
	if (locale === "fr") return fr_action__open_panel(inputs)
	if (locale === "it") return it_action__open_panel(inputs)
	if (locale === "nl") return nl_action__open_panel(inputs)
	return pt_action__open_panel(inputs)
};